import { ExtractCssFromPropsFn } from '../../core.types';
import { createMediaQuery } from './createMediaQuery';

export const parseResponsiveObject = (
  breakpoints: object,
  extractCssFromProps: ExtractCssFromPropsFn,
  scale: object,
  raw: object,
  _props?: object,
) => {
  const styles: Record<string, string> = {};
  for (const key in raw) {
    const breakpoint = breakpoints[key as keyof typeof breakpoints];
    const value = raw[key as keyof typeof raw];
    const style = extractCssFromProps(value, scale, _props);
    if (!breakpoint) {
      Object.assign(styles, style);
    } else {
      const media = createMediaQuery(breakpoint);
      Object.assign(styles, {
        [media]: Object.assign({}, styles[media], style),
      });
    }
  }
  return styles;
};
